// ═══════════════════════════════════════════════════════════════════
//  modules/courriel/MaSignature.js
//  MaSignature
// ═══════════════════════════════════════════════════════════════════

import { useEffect, useState } from "react";
import { API_BASE } from "../../socle/api";
import { THEME } from "../../socle/theme";
import { btnStyle, mailHeaders } from "./utils";

// ═══════════════════════════════════════════════════════════════════════
//  MA SIGNATURE — propre à chaque membre du staff
//  C'est la personne qui écrit qui signe : la signature enregistrée ici est
//  ajoutée automatiquement à tous SES envois, et à aucun autre.
// ═══════════════════════════════════════════════════════════════════════
export function MaSignature({ token, user, onClose }) {
  const [texte, setTexte] = useState("");
  const [infos, setInfos] = useState(null);
  const [enregistre, setEnregistre] = useState(false);
  const [erreur, setErreur] = useState(null);

  useEffect(() => {
    fetch(`${API_BASE}/api/mail/signature`, { headers: mailHeaders(token) })
      .then((r) => r.json())
      .then((j) => { setInfos(j); setTexte(j.signature || ""); })
      .catch(() => setErreur("Signature illisible."));
  }, [token]);

  const enregistrer = async () => {
    setErreur(null);
    try {
      const res = await fetch(`${API_BASE}/api/mail/signature`, {
        method: "PUT", headers: mailHeaders(token), body: JSON.stringify({ signature: texte }),
      });
      const json = await res.json();
      if (!json.success) throw new Error(json.error || "échec");
      setInfos((i) => ({ ...i, defaut: json.defaut, personnalisee: Boolean(texte.trim()) }));
      setEnregistre(true);
      setTimeout(() => setEnregistre(false), 2500);
    } catch (e) { setErreur(e.message); }
  };

  const modele = `${user?.discordUsername || "Prénom"}\nÉquipe Orialis\nboxoria.staff@boxoria.fr`;

  return (
    <div onClick={(e) => e.target === e.currentTarget && onClose()} style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,.6)", zIndex: 1000,
      display: "flex", alignItems: "center", justifyContent: "center", padding: 16,
    }}>
      <div style={{ background: THEME.surface, border: `1px solid ${THEME.border}`, borderRadius: 14,
                    width: "100%", maxWidth: 560, maxHeight: "90vh", overflowY: "auto",
                    padding: 20, boxSizing: "border-box" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
          <div style={{ color: THEME.text, fontSize: 17, fontWeight: 800 }}>✍ Ma signature</div>
          <button onClick={onClose} style={btnStyle()}>✕</button>
        </div>

        <div style={{ color: THEME.textMuted, fontSize: 12.5, marginBottom: 14, lineHeight: 1.55 }}>
          Cette signature est ajoutée automatiquement à la fin de <b>tes</b> envois — chaque membre du staff
          a la sienne. Les messages partent toujours depuis la boîte staff, mais ton nom apparaît dans
          l'expéditeur :{" "}
          {infos?.nomExpediteur && (
            <span style={{ color: THEME.accent, fontFamily: "monospace", fontSize: 12 }}>{infos.nomExpediteur}</span>
          )}
        </div>

        <label style={{ color: THEME.textMuted, fontSize: 11, fontWeight: 700, letterSpacing: ".08em" }}>SIGNATURE</label>
        <textarea value={texte} onChange={(e) => setTexte(e.target.value)} rows={7}
          placeholder={modele}
          style={{ width: "100%", boxSizing: "border-box",
                   background: THEME.panel, border: `1px solid ${THEME.border}`, borderRadius: 8,
                   padding: "11px 12px", color: THEME.text, fontSize: 13, outline: "none", marginTop: 5,
                   fontFamily: "inherit", lineHeight: 1.55, resize: "vertical" }} />

        {!texte.trim() && (
          <div style={{ color: THEME.textDim, fontSize: 11.5, marginTop: 6 }}>
            Champ vide : une signature par défaut est générée à partir de ton pseudo.
          </div>
        )}

        {infos?.defaut && (
          <div style={{ background: THEME.panel, border: `1px solid ${THEME.border}`, borderRadius: 8,
                        padding: "10px 12px", marginTop: 14 }}>
            <div style={{ color: THEME.textDim, fontSize: 10.5, fontWeight: 800, letterSpacing: ".08em", marginBottom: 5 }}>
              APERÇU DE CE QUI SERA AJOUTÉ
            </div>
            <div style={{ color: THEME.textMuted, fontSize: 12.5, whiteSpace: "pre-wrap", fontFamily: "monospace" }}>
              {"-- \n"}{texte.trim() ? texte : infos.defaut}
            </div>
          </div>
        )}

        {erreur && <div style={{ color: THEME.red, fontSize: 12.5, marginTop: 10 }}>{erreur}</div>}

        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", marginTop: 16, alignItems: "center" }}>
          {enregistre && <span style={{ color: THEME.emerald, fontSize: 12.5 }}>✓ Enregistrée</span>}
          <button onClick={onClose} style={btnStyle()}>Fermer</button>
          <button onClick={enregistrer} style={btnStyle(true)}>Enregistrer</button>
        </div>
      </div>
    </div>
  );
}
